interface GetUrlSearchParamsOptions {
  keys?: string[];
}

export function getUrlSearchParams({ keys }: GetUrlSearchParamsOptions) {
  const url = new URL(window.location.href);
  if (!keys || !keys.length) return [];
  return keys.map((key) => url.searchParams.get(key)) ?? [];
}
